import { defineFilterSpec, enumField, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { OrderHistoryFilterFormValues, OrderHistoryFilters } from './types';

/** Order History tab filter serialization (drawer draft <-> applied <-> query), shared by
 *  the drawer, the list api, and the page/export. Field/param names match the real
 *  `GetCustomerOrdersDto` directly (`orderStatus`, `orderDateFrom/To`, `deliveryDateFrom/To`,
 *  `paymentMethod` singular, `itemCountFrom/To`) — the FE-invented names never existed on the
 *  backend. */
const spec = defineFilterSpec<OrderHistoryFilters, OrderHistoryFilterFormValues>([
  text('search'),
  multiField('orderStatus'),
  multiField('paymentMethods', 'paymentMethod'),
  enumField('orderDateFrom'),
  enumField('orderDateTo'),
  enumField('deliveryDateFrom'),
  enumField('deliveryDateTo'),
  rangeField('amount'),
  rangeField('items', { param: 'itemCount' }),
]);

export const orderHistoryToListQuery = spec.toListQuery;
export const orderHistoryToDefaults = spec.toDefaults;
export const orderHistoryToFilters = spec.toFilters;
export const orderHistoryHasActiveFilters = spec.hasActiveFilters;
